export const AdminUserRole = {
    All: "*",
    SuperAdmin: "Super Admin",
    CustomerService: "Customer Service",
    CustomerServiceAdmin: "Customer Service Admin",
    Ecommerce: "Ecommerce",
    EcommerceAdmin: "Ecommerce Admin",
    EcommerceTester: "Ecommerce Tester",
    Dealer: "Dealer",
    Cashier: "Cashier",
    SalesAdmin: "Sales Admin"
};

export type RolesType = (typeof AdminUserRole)[keyof typeof AdminUserRole];